//To generate dates for the next quarter of the year
import { DateTime } from 'scaleflow/utils/date-time';

export function getNextQuarterDates() {
  const today = DateTime.now(); // Get current date
  const currentQuarter = Math.ceil((today.month() + 1) / 3); // Determine current quarter
  const nextQuarter = (currentQuarter % 4) + 1; // Calculate next quarter

  // Start of next quarter
  const startOfNextQuarter = DateTime.now()
    .withMonth(nextQuarter * 3 - 3)
    .startOf('month');
  // End of next quarter
  const endOfNextQuarter = DateTime.now()
    .withMonth(nextQuarter * 3 - 1)
    .endOf('month');

  return {
    start: startOfNextQuarter.format('YYYY-MM-DDT00:00:00.000Z'),
    end: endOfNextQuarter.format('YYYY-MM-DDT00:00:00.000Z'),
  };
}
